import {
    SET_LISTING_STATUS,
    SET_LISTING,
    SET_MARKET_REPORT,
    SET_CURRENT_LISTING_STATUS,
    SET_FETCH_LISTING_STATUS,
    SET_FETCH_MARKET_REPORT_STATUS,
    // SET_IS_SEARCH_INIT,
    SET_TOTAL_PAGE,
    SET_PAGE_NUM,
    SET_CURRENT_LISTING_NAME,
    SET_MORE_BTN_TITLE,
    SET_MORE_BTN_STYLE,
    SET_LISTING_TITLE,
    SET_SHOW_LISTING_PRICE,
    SET_SHOW_SOLD_LISTING_PRICE,
    UPDATE_SEARCH_PARAMS
} from './constants';
export default {
    // 设置 md-search 是否已完成初始化
    // [SET_IS_SEARCH_INIT](state, payload = {}) {
    //     state.isSearchInit = payload.data;
    // },
    // 设置 listingStatus 的值
    [SET_LISTING_STATUS](state, payload = {}) {
        state.listingStatus = [...payload.data];
    },
    // 设置 listing 的值
    [SET_LISTING](state, payload = {}) {
        state.listing = [...payload.data];
    },
    // 设置 marketReport 的值
    [SET_MARKET_REPORT](state, payload = {}) {
        state.marketReport = { ...payload.data };
    },
    // 设置 currentListingStatus 的值
    [SET_CURRENT_LISTING_STATUS](state, payload = {}) {
        state.currentListingStatus = payload.data;
    },
    // 设置 currentListingStatus 的值
    [SET_FETCH_LISTING_STATUS](state, payload = {}) {
        state.fetchListingStatus = payload.data;
    },
    [SET_CURRENT_LISTING_NAME](state, payload = {}) {
        state.currentListingStatusName = payload.data;
    },
    // 设置 fetchMarketReportStatus 的值
    [SET_FETCH_MARKET_REPORT_STATUS](state, payload = {}) {
        state.fetchMarketReportStatus = payload.data;
    },
    // 设置分页的总页数
    [SET_TOTAL_PAGE](state, payload = {}) {
        state.totalPage = payload.data;
    },
    // 设置当前页
    [SET_PAGE_NUM](state, payload = {}) {
        state.pageNum = payload.data;
    },
    // 设置 more button
    [SET_MORE_BTN_TITLE](state, payload = {}) {
        state.moreBtnTitle = payload.data;
    },
    [SET_MORE_BTN_STYLE](state, payload = {}) {
        state.moreBtnStyle = payload.data;
    },
    [SET_LISTING_TITLE](state, payload = {}) {
        state.customListingTitle = payload.data;
    },
    // 是否显示sold listing price
    [SET_SHOW_SOLD_LISTING_PRICE](state, payload = {}) {
        state.showSoldPrice = payload.data;
    },
    // 是否显示listing price
    [SET_SHOW_LISTING_PRICE](state, payload = {}) {
        state.showListingPrice = payload.data;
    },
    [UPDATE_SEARCH_PARAMS](state, payload) {
        state.searchParams = { ...payload };
    }
};
